<template>
  <section id="home">
    <hero style="height: calc(100vh - 136px);" />

    <v-slide-y-reverse-transition>
      <div v-show="$store.state.visitorType">
        <v-responsive
          class="overflow-visible"
          min-height="50vh"
        >
          <v-row
            align="center"
            align-content="center"
            class="fill-height mx-0"
            justify="space-around"
          >
            <v-slide-y-reverse-transition appear>
              <v-col
                cols="12" md="8"
              >
                <base-card class="pa-12">
                  <v-row class="text-center">
                    <v-col
                      v-for="(highlight, i) in highlights"
                      :key="i"
                      cols="12"
                      md="4"
                    >
                      <v-img
                        :src="require(`@/assets/highlights/${highlight.src}`)"
                        class="mb-8"
                        contain
                        max-height="190"
                        width="95%"
                      />

                      <h2
                        class="headline font-weight-bold mb-6"
                        v-text="highlight.title"
                      />

                      <v-responsive
                        max-width="300"
                        class="grey--text text-left pl-2 body-1 mx-auto"
                        v-text="highlight.text"
                      />
                    </v-col>
                  </v-row>
                </base-card>
              </v-col>
            </v-slide-y-reverse-transition>
          </v-row>
        </v-responsive>
        
        <v-video style="margin-top: 10vh;" />

        <features />

        <stack class="mt-6" v-if="$vuetify.breakpoint.smAndUp" />

        <guarantees />

        <v-container tag="section" id="pricing" fluid class="mt-10 mb-4">
          <base-subheading
            class="mb-12"
            subtitle="
              <p style='font-size: 20px !important;' class='overline'>Hassle-free medical billing for only...</p>
            "
            title="
              <p style='text-decoration: underline; text-decoration-color: #55E6CC;' class='font-weight-medium'>Know how to bill every patient, every time.</p>
            "
          />
          <v-row
            justify="center"
          >
            <v-col
              cols="12"
              md="9" class="pt-4"
            >
              <!-- <v-lazy transition="slide-y-reverse-transition"> -->
                  <!-- <v-img eager src="@/assets/art/pricing.svg"></v-img> -->
                  <Pricing/>
              <!-- </v-lazy> -->
            </v-col>
            
            <v-col cols="12" align="center" class="mt-10 body-1 pb-0 font-italic font-weight-light">* A <span class='font-weight-medium'>provider</span> is an active Doctor, Physician, or Clinician at your practice.</v-col>
            <v-col cols="12" align="center" class="body-1 pt-0 font-italic font-weight-light">* <span class='font-weight-medium'>Mid-level staff</span> are active Physician Assistants or Registered Nurses at your practice.</v-col>
            
            <v-col cols="12" align="center" class="title pt-6 font-weight-light">Looking to use Billit in <span class='font-weight-medium'>the classroom? </span>
              <span style="cursor: pointer;" @click="$vuetify.goTo(pageHeight)">Contact us</span>
              for free-forever access to Billit.
            </v-col>
          </v-row>
        </v-container>

        <!-- prod todo: when we have some customers uncomment this and put actual data -->
        <!-- <market /> -->

        <stay-informed />
      </div>
    </v-slide-y-reverse-transition>

    <div v-if="!$store.state.visitorType" class="landing-sections">
      <v-img contain max-width="25vw" :src="require('@/assets/art/iam.svg')"></v-img>
      <div style="padding-left: 10%; flex-basis: 40%;" class="text-center">
        <p class="display-1 font-weight-bold text-center mb-6">Welcome to Billit! <br> <span class="headline grey--text">I am a...</span></p>
        <div class="landing-sections__options">
          <v-btn @click="$store.commit('setVisitorType', 'practice')" outlined color="primary" class="text-capitalize font-weight-bold" large style="border-width: 2px !important; border-radius: 8px !important;">Healthcare Practice</v-btn>
          <v-btn @click="$store.commit('setVisitorType', 'agency')" outlined color="primary" class="text-capitalize font-weight-bold" large style="border-width: 2px !important; border-radius: 8px !important;">Billing Agency</v-btn>
        </div>
        <v-btn @click="$store.commit('setVisitorType', 'browsing')" text small color="grey" class="text-capitalize font-weight-regular" style="margin-bottom: -30%; font-size: 0.9em !important;">I'm Just Browsing</v-btn>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {
      }
    },
    computed: {
      pageHeight() {
        return document.documentElement.scrollHeight
      },
      highlights() {
        if (this.$store.state.visitorType === 'practice') {
          return [
            {
              src: '1.svg',
              title: 'Easy to use? You bet.',
              text: 'For front desk, billers & collectors: Billit gives you the ability to view a complete list of insurance carriers and plans across the US, look at billing instructions tailored to your practice for each of those plans, and to identify the plan that any card belongs to through our step-by-step card identification tool.',
            },
            {
              src: '2.svg',
              title: 'We do the prep',
              text: 'With features like a complete list of over 30+ carriers and 300+ plans, a step-by-step tool for finding out what plan a card belongs to based on its appearance, and a central place to put your billing instructions for every plan - we ensure you’ll hit the ground running with an effective billing process in any scenario.'
            },
            {
              src: '3.svg',
              title: 'You write the steps',
              text: 'When signing up, all we need from you is to write out your billing instructions for the insurance plans you accept, or for you to pick pre-written instructions based on the patient intake software your practice uses (if any). This way, the right staff can follow the right instructions at the right times.'
            },
          ]
        } else if (this.$store.state.visitorType === 'agency') {
          return [
            {
              src: '1.svg',
              title: 'Easy to use? You bet.',
              text: 'For billing staff & collectors: All you need to do is open Billit in a web browser to view both the full list of insurance carriers & plans that each of your clients accept, and the custom billing instructions tailored to each of your clients billing methods for them. All in one place!',
            },
            {
              src: '2.svg',
              title: 'We do the prep',
              text: 'With features like a tool to find what plan any card belongs to based on its appearance, a built-in list of over 30+ carriers & 300+ plans, and the ability to store billing instructions tailored to each of your client’s billing methods inside them, we assure you the best billing strategy!'
            },
            {
              src: '3.svg',
              title: 'You write the steps',
              text: 'When signing up, all we need from you is to write out each of your client’s billing instructions for the plans they accept, or for you to pick pre-made instructions based on the eligible softwares they use (if any). This way, your staff can follow the right steps for the right clients.'
            },
          ]
        } else if (this.$store.state.visitorType === 'browsing') {
          return [
            {
              src: '1.svg',
              title: 'Easy to use? You bet.',
              text: 'For practices & agencies: All you need to do is open Billit in a web browser in order to view both the full list of insurance carriers & plans that your practice or each of your agency’s clients accept, and to view the custom billing instructions tailored to you or your client’s billing methods inside them. All in one place!',
            },
            {
              src: '2.svg',
              title: 'We do the prep',
              text: 'With features like a full list of over 30+ carriers and 300+ plans, a step-by-step tool for finding out what plan a card belongs to based on its appearance, and a central place to store billing instructions for every plan that your practice or each of your agency’s clients accept - we give you a better billing system!'
            },
            {
              src: '3.svg',
              title: 'You write the steps',
              text: 'When signing up, all we need from you is to write out you or your client’s billing instructions for the insurance plans that you or your clients accept, or for you to pick pre-made instructions based on the patient intake software you or your clients use. This way, staff can use the right steps at the right times.'
            },
          ]
        } else {
          return []
        }
      }
    },
    mounted() {
      setTimeout(() => {
        if (this.$route.hash === '#pricing' || this.$route.name === 'Pricing') { 
          this.$store.commit('setVisitorType', 'browsing')
          setTimeout(() => {
            this.$vuetify.goTo('#pricing', {easing: 'easeInOutQuad' })
          }, 300)
        }
        
        if (this.$route.hash === '#practice') {
          this.$store.commit('setVisitorType', 'practice')
        } else if (this.$route.hash === '#agency') {
          this.$store.commit('setVisitorType', 'agency')
        } else if (this.$route.hash === '#browsing') {
          this.$store.commit('setVisitorType', 'browsing')
        }
      }, 300)
    },
    components: {
      Hero: () => import('./Hero'),
      Features: () => import('./Features'),
      VVideo: () => import('./Video'),
      Market: () => import('./Market'),
      Stack: () => import('./Stack'),
      Guarantees: () => import('./Guarantees'),
      StayInformed: () => import('./StayInformed'),
      Pricing: () => import('@/components/misc/Pricing')
    },
  }
</script>

<style lang="sass">
  #home section
    padding: 32px 16px 96px

    @media screen and (max-width: 360px)
      padding: 32px 16px

  
  .landing-sections 
    // margin-top: -10%
    min-height: 60vh
    margin-bottom: 5vh
    display: flex
    justify-content: center
    align-items: center

  .landing-sections__options
    display: flex
    justify-content: space-around
</style>
